import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            // Prefix "SVC_BLACKBOARD_DATA_" can't be edited, so it's greyed out
            prefixAdornment: {
                color: theme.palette.text.disabled,
                whiteSpace: 'nowrap',
            },
            // Error and hint each sit on their own line, error first.
            suffixHintText: {
                display: 'block',
                color: theme.palette.text.secondary,
                overflowWrap: 'anywhere',
            },
            suffixErrorText: {
                display: 'block',
                color: theme.palette.error.main,
                overflowWrap: 'anywhere',
            },
            previewName: {
                fontWeight: 600,
                overflowWrap: 'anywhere',
            },
        }),
    {
        name: 'CreateServiceAccountDialog-',
    },
);
